import { TRPCClientError } from "@trpc/client";

import type { AppRouter } from "@degaus/trpc";

export function checkIsNotFoundError(error: unknown): boolean {
  if (checkIsTrpcClientError(error)) {
    return error.data?.code === "NOT_FOUND";
  }
  return false;
}

export function checkIsForbiddenError(error: unknown): boolean {
  if (checkIsTrpcClientError(error)) {
    return error.data?.code === "FORBIDDEN";
  }
  return false;
}

export function checkIsTrpcClientError(
  error: unknown,
): error is TRPCClientError<AppRouter> {
  return error instanceof TRPCClientError;
}

export function checkIsUnauthorizedError(error: unknown): boolean {
  if (checkIsTrpcClientError(error)) {
    return error.data?.code === "UNAUTHORIZED";
  }
  return false;
}
